import api from './_api';

const getOffers = () => api.get('/offers');

const isThereASoldOutOffer = async (cart, players) => {
  let foundSoldOut = false;
  let offersData = (await getOffers()).data;
  const cartWeeks = cart.articles.map((article) => article.week);
  const packagesIds = players.map((player) => player.stage.packageId);
  offersData = offersData.offers.filter(
    (offer) => cartWeeks.includes(offer.weekId) && packagesIds.includes(offer.packageId),
  );
  if (offersData) {
    offersData.forEach((offer) => {
      if (offer.flag === 'SOLD_OUT') {
        foundSoldOut = true;
      }
    });
  }
  return foundSoldOut;
};

// isThereASoldOutOption and related helpers removed (moved to server-side validation)

const offersService = {
  getOffers,
  isThereASoldOutOffer,
};

export default offersService;
